import { createIcon } from "../create-icon"

export const UpIcon = createIcon({
  title: "UpIcon",
  viewBox: "0 0 16 16",
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.23966 10.2996C4.5432 10.5814 5.01775 10.5639 5.2996 10.2603L8 7.35221L10.7004 10.2603C10.9823 10.5639 11.4568 10.5814 11.7603 10.2996C12.0639 10.0177 12.0815 9.5432 11.7996 9.23966L8.5496 5.73966C8.40769 5.58684 8.20856 5.5 8 5.5C7.79145 5.5 7.59232 5.58684 7.45041 5.73966L4.20041 9.23966C3.91856 9.54319 3.93613 10.0177 4.23966 10.2996Z"
      fill="currentColor"
    />
  ),
})

UpIcon.displayName = "UpIcon"
